module.exports = __webpack_public_path__ + "img/almaza.50e29413.png";